var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Weekdays } from '@/models/CampaignOperation';
import { locationGroupType } from '@/components/Advertiser/Operation/PointGroup/PointGroupOperation/constants';
/** 配信時間帯設定の型変換 */
export var translateWeeklyDeliverySchedule = function (deliveryTimeSchedules) {
    return Weekdays.map(function (day) {
        return deliveryTimeSchedules.map(function (schedule) { return (__assign({ day: day }, schedule)); });
    }).flat();
};
var isDeleted = function (group) {
    if (!isUsableGroup(group)) {
        return true;
    }
    return group.status === 'inactive';
};
var isUsableGroup = function (group) {
    // 地点グループの保有確認
    if (group.simulationLocations.length === 0) {
        return false;
    }
    // 有効な地点の保有確認
    return group.simulationLocations.some(function (g) { return g.status === 'active'; });
};
/** 配信地点グループの型変換 */
export var translateDeliveryLocationGroups = function (menuSetting) {
    var simulationCustomLocationGroups = menuSetting.simulationCustomLocationGroups.map(function (group) {
        return {
            id: group.id,
            locationGroupId: group.id,
            locationType: locationGroupType.CUSTOM_LOCATION,
            name: group.name,
            radius: group.radius,
            creativeSchedules: [],
            isUsable: isUsableGroup(group),
            deleted: isDeleted(group),
            isSimulation: true,
            accessibleType: 'public',
        };
    });
    var simulationPoiLocationGroups = menuSetting.simulationPoiLocationGroups.map(function (group) {
        return {
            id: group.id,
            locationGroupId: group.id,
            locationType: locationGroupType.POI_LOCATION,
            name: group.name,
            radius: group.radius,
            administrativeDistrictType: group.administrativeDistrictType,
            area: group.area,
            categoryId: group.categoryId,
            conditions: group.conditions,
            creativeSchedules: [],
            isUsable: true,
            deleted: group.status === 'inactive',
            isSimulation: true,
            accessibleType: 'public',
        };
    });
    return __spreadArray(__spreadArray([], simulationCustomLocationGroups, true), simulationPoiLocationGroups, true);
};
